<template>
  <header class="sticky top-0 z-40 backdrop-blur-md" style="background: var(--surface-nav); border-bottom: 1px solid var(--rule);">
    <div class="max-w-6xl w-full mx-auto px-6 lg:px-16 h-16 flex items-center justify-between">
      <RouterLink to="/" class="font-bold text-base tracking-tight text-ink hover:text-clay-700 transition-colors duration-normal ease-out-expo">
        Calmren
      </RouterLink>

      <nav class="flex items-center gap-4 sm:gap-8">
        <RouterLink
          v-for="link in links"
          :key="link.to"
          :to="link.to"
          class="font-mono text-xs uppercase tracking-widest text-muted hover:text-ink transition-colors duration-fast"
        >
          {{ link.label }}
        </RouterLink>
      </nav>
    </div>
  </header>
</template>

<script setup lang="ts">
import { RouterLink } from 'vue-router'

const links = [
  { to: '/field-notes', label: 'Field notes' },
  { to: '/contact',     label: 'Contact' },
]
</script>
